import React, { useEffect, useState } from 'react'
import { Box, Button, Typography, TextField, MenuItem, Stack, Checkbox } from '@mui/material'
import Modal from '../../../common/modal'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useAtom } from 'jotai'
import { alertAtom } from './../../../common/jotaiState/globalStateAtoms'
import { urls } from '../../../common/constants'
import { PostRequest } from '../../../common/api'
import { useTranslation } from '../../../../i18n/I18nProvider'
const ExpenseHeadsModal = (props) => {
  const { updateModal, headTxt, selectedTab, isUpdate, editData, loginData, fetchTableData,expenseHeadDetailsTableData } = props
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [, setAlert] = useAtom(alertAtom)
  const [formData, setFormData] = useState({
    AccountHead: '',
    AccountSubHead: '',
    ExpenseType: '',
    isActive: 0,
    AccountSubHeadID:0,
  })
  useEffect(() => {
    if (isUpdate && editData) {
      setFormData({
        AccountHead: editData.AccountHead,
        AccountSubHead: editData.AccountSubHead,
        ExpenseType: editData.ExpenseType,
        isActive: editData.Active,
        AccountSubHeadID: editData.AccountSubHeadID ?? true,
      })
    }
  }, [editData, isUpdate])

  const accountHeads = [
    { value: 1, AccountHead: 'Snacks', label: 'Staff Welfare Cost', ExpenseType: 'DailyExpense' },
    { value: 2, AccountHead: 'Stationery', label: 'Office Supplies', ExpenseType: 'Admit Cast' },
    { value: 3, AccountHead: 'Fuel', label: 'Vehicle Expense', ExpenseType: 'Operation Cast' },
    { value: 4, AccountHead: 'Fuel', label: 'Vehicle Expense', ExpenseType: 'Marketing Cast' },
    { value: 5, AccountHead: 'Fuel', label: 'Vehicle Expense', ExpenseType: 'Staff Welfare Cast' },
    { value: 6, AccountHead: 'Fuel', label: 'Vehicle Expense', ExpenseType: 'Tranportration Cast' },
    { value: 7, AccountHead: 'Fuel', label: 'Vehicle Expense', ExpenseType: 'Maintenance Cast' },
  ];
  const handleSave = (formData, key) => {
    if (key === 'ExpenseHeadSave') {
      if (formData.AccountHead === '') {
        setAlert({ show: true, success: true, msg: tr('ehPleaseEnterAccountHead', 'Please Enter Account Head Name'), nextId: '' })
      } else if (formData.ExpenseType === '') {
        setAlert({ show: true, success: true, msg: tr('ehPleaseSelectExpenseType', 'Please Select Expense Type'), nextId: '' })
      } else {
        const obj = {
          intAccountHeadID: isUpdate ? editData.AccountHeadID : 0,
          strHeadName: formData.AccountHead,
          blnIsActive: formData.isActive,
          intCompanyID: loginData.intCompanyID,
          strHeadType: formData.ExpenseType
        }
        PostRequest(urls.accountHeadsInsertUpdate, obj).then((res) => {
          if (res.status === 'Success') {
            fetchTableData()
            setAlert({ show: true, success: true, msg: tr('ehLuggageSettingUpdated', 'Comapany Luggage Setting updated successfully'), nextId: '' })
          } else {
            setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
          }
        })
      }
    } else {
      if (formData.AccountSubHead === '') {
        setAlert({ show: true, success: true, msg: tr('ehPleaseEnterAccountHead', 'Please Enter Account Head Name'), nextId: '' })
      } else if (formData.AccountHead === '') {
        setAlert({ show: true, success: true, msg: tr('ehPleaseSelectExpenseType', 'Please Select Expense Type'), nextId: '' })
      } else {
        const obj = {
          intAccountHeadID:isUpdate ? editData.AccountHeadID : formData.AccountSubHeadID,
          AccountSubHeadID:isUpdate?editData.AccountSubHeadID:0,
          strsubHeadName: formData.AccountSubHead,
          blnIsActive: formData.isActive,
        }
        PostRequest(urls.subAccountHeadsInsertUpdate, obj).then((res) => {
          if (res.status === 'Success') {
            fetchTableData()
            setAlert({ show: true, success: true, msg: tr('ehLuggageSettingUpdated', 'Comapany Luggage Setting updated successfully'), nextId: '' })
          } else {
            setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
          }
        })
      }
    }
  }
  const handleChange = (field) => (event) => {
    const value = field === 'isActive' ? event.target.checked?1:0 : event.target.value
    setFormData((prev) => ({ ...prev, [field]: value, }))
  }

  const handleClose = () => {
    updateModal(false)
  }

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  const textFieldSx = {
    '& .MuiInputBase-input': {
      fontSize: '1.8rem',
      padding: '9.5px 14px'
    },
  }

  const selectMenuProps = {
    MenuProps: {
      PaperProps: {
        sx: {
          fontSize: '1.8rem',
        },
      },
    },
  };

  return (
    <Modal
      headTxt={headTxt}
      width={'40%'}
      height={'360px'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      {selectedTab === 47 ? (
        <Stack style={{ maxHeight: '90vh', padding: '2rem 4rem' }} spacing={3}>
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 800 }}>
              {tr('ehAccountHeadName', 'Account Head Name')}
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={formData.AccountHead}
              onChange={handleChange('AccountHead')}
              sx={{ ...textFieldSx }}
              {...selectMenuProps}
            />
          </Box>

          <Box disabled>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 800 }}>
              {tr('ehSelectExpenseType', 'Select Expense Type')}
            </Typography>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={'Select_ExpenseType'}
                // label={'Select Consignment Type'}
                data={accountHeads}
                defaultvalue={formData.ExpenseType || ''}
                onSelect={(val) => { setFormData((prev) => ({ ...prev, ExpenseType: val.ExpenseType })) }}
                idKey={`value`}
                dataKey={`ExpenseType`}
                minWidth="100%"
                prevId={``}
                nextId={''}
                disabled={isUpdate && true}
              />
            </Item>

          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={4}>
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={formData.isActive}
                onChange={handleChange('isActive')}
                size="large"
                color="success"
                sx={{ transform: 'scale(1.3)' }}
              />

              <Typography sx={{ fontSize: '1.5rem' }}>{tr('ehIsActive', 'IS ACTIVE')}</Typography>
            </Box>

            {/* Right: Buttons */}
            <Box display="flex" gap={2}>
              <Button id="cancelModalBtn" className="cancel-btn" variant="outlined" color="error" onClick={handleClose}>
                {tr('ehClose', 'Close')}
              </Button>
              <Button
                id="saveBtn"
                style={{ margin: '0', height: '40px' }}
                className="btn add-btn"
                variant="contained"
                color="error"
                onClick={() => (handleSave(formData, 'ExpenseHeadSave'), updateModal(false))}
              >
                {tr('saveTitle', 'Save')}
              </Button>
            </Box>
          </Box>
        </Stack>
      ) : (
        <Stack style={{ maxHeight: '90vh', padding: '2rem 4rem' }} spacing={3}>
          {/* Sub Head Name */}
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 800 }}>
              {tr('ehAccountSubHeadName', 'Account Sub Head Name')}
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={formData?.AccountSubHead}
              onChange={handleChange('AccountSubHead')}
              sx={textFieldSx}
              {...selectMenuProps}
            />
          </Box>

          {/* Select Account Head */}
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 800 }}>
              {tr('ehSelectAccountHead', 'Select Account Head')}
            </Typography>
            {isUpdate?
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={'Select_ExpenseType'}
                // label={'Select Consignment Type'}
                data={accountHeads}
                defaultvalue={formData.AccountHead || ''}
                onSelect={(val) => { setFormData((prev) => ({ ...prev, AccountHead: val.ExpenseType,AccountSubHeadID:val.value })) }}
                idKey={`value`}
                dataKey={`ExpenseType`}
                minWidth="100%"
                prevId={``}
                nextId={''}
                disabled={isUpdate && true}
              />
            </Item>:<Item sx={sx.itemsx}>
              <DropDownOA
                id={'Select_ExpenseType'}
                // label={'Select Consignment Type'}
                data={expenseHeadDetailsTableData}
                defaultvalue={formData.AccountHead || ''}
                onSelect={(val) => { setFormData((prev) => ({ ...prev, AccountHead: val.HeadName,AccountSubHeadID:val.AccountHeadID })) }}
                idKey={`AccountHeadID`}
                dataKey={`HeadName`}
                minWidth="100%"
                prevId={``}
                nextId={''}
                disabled={isUpdate && true}
              />
            </Item>
            }
            
          </Box>

          {/* Footer with Checkbox & Buttons */}
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={4}>
            {/* Left: Is Active */}
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={formData.isActive}
                onChange={handleChange('isActive')}
                size="large"
                color="success"
                sx={{ transform: 'scale(1.3)' }}
              />

              <Typography sx={{ fontSize: '1.5rem' }}>{tr('ehIsActive', 'IS ACTIVE')}</Typography>
            </Box>

            {/* Right: Buttons */}
            <Box display="flex" gap={2}>
              <Button id="cancelModalBtn" className="cancel-btn" variant="outlined" color="error" onClick={handleClose}>
                {tr('ehClose', 'Close')}
              </Button>
              <Button
                id="saveBtn"
                style={{ margin: '0', height: '40px' }}
                className="btn add-btn"
                variant="contained"
                color="error"
                onClick={() => (handleSave(formData, 'ExpenseSubHeadSave'), updateModal(false))}
              >
                {tr('saveTitle', 'Save')}
              </Button>
            </Box>
          </Box>
        </Stack>
      )}
    </Modal>
  )
}

export default ExpenseHeadsModal
